module.exports = require("hdkey");